import Text from '@creator/ui/components/Text/Text';
import { cn } from '@creator/ui/utils/ui';
import Link from '@src/basic-components/Link/Link';
import PostByline from '@src/components/Post/PostByline';
import { ensureTokenUrl } from '@src/model/config/helpers';
import { ensurePostUrl } from '@src/model/upvote/helpers';
import { usePost } from '@src/store/posts/hooks/usePost';
import type { FC } from 'react';

export interface PostTitleAndBylineProps {
    className?: string;
    postId: string;
    tokenName: string;
}

export const PostTitleAndByline: FC<PostTitleAndBylineProps> = props => {
    const { postId, tokenName, className } = props;
    const post = usePost(postId);

    const postUrl = `/${ensureTokenUrl(tokenName)}/${ensurePostUrl(postId, true)}`;
    function renderTitle() {
        return (
            <Link to={postUrl}>
                <Text data-ssr="post-title" enableMultiline={true} as="h1" className="text-base font-bold leading-tight lg:text-xl line-clamp-2">
                    {post?.title}
                </Text>
            </Link>
        );
    }

    return (
        <div className={cn('space-y-2', className)}>
            {renderTitle()}
            <PostByline className="h-5" tokenName={tokenName} postId={postId} />
        </div>
    );
};
